import React from 'react';

interface LoadingScreenProps {
  message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = "Loading..." 
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center relative">
      {/* Global Blue Gradient Background */}
      <div className="fixed inset-0 pointer-events-none z-0">
        {/* Main gradient background - blue to white */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#007AFF]/60 via-[#007AFF]/10 to-white" style={{
          background: 'linear-gradient(to bottom, #007AFF60 0%, #007AFF40 10%, #007AFF20 25%, #007AFF10 40%, #007AFF05 55%, white 70%)'
        }}></div>

        {/* Subtle animated elements */}
        <div className="absolute top-20 left-20 w-96 h-96 bg-white/30 rounded-full blur-3xl animate-pulse"></div>
        <div 
          className="absolute bottom-20 right-20 w-80 h-80 bg-white/20 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "1s" }}
        ></div>
        <div 
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/15 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: "2s" }}
        ></div>
      </div>

      {/* Loading message */}
      <div className="relative z-10">
        <div className="text-gray-900 text-xl">{message}</div>
      </div>
    </div>
  );
};